module.exports = __webpack_public_path__ + "static/media/ficpa.8b21a1eb.png";